/**
 * 请求封装
 */
import * as urls from './request.urls';
import * as util from './util';

const sessionId = util.getSessionId();
const clientInfo = JSON.stringify({
	sourceType: 1001
});

export default {
	sendFeedBack() {
		return {
			url: urls.BaseUrl + '/autoCustom/sendFeedback',
			method: 'POST',
			formatRule(params) {
				return {
					clientInfo,
					userId: params.bid,
					from: params.sourceType,
					channel: params.channel,
					sessionId, //会话session id，每次新打开客服聊天页面，创建一个随机session id
					feedbackId: params.msgId, //机器人客服消息id
					result: params.result //反馈内容 0-有用 1－没用
				};
			}
		};
	},

	sendMessage() {
		return {
			url: urls.BaseUrl + '/autoCustom/sendQuestion',
			method: 'POST',
			formatRule(params) {
				return {
					from: params.sourceType,
					clientInfo,
					userId: params.bid,
					channel: params.channel,
					sessionId, //会话session id，每次新打开客服聊天页面，创建一个随机session id
					question: params.question //消息内容
				};
			}
		};
	},

	getUserInfo() {
		return {
			url: urls.BaseUrl + '/follow/info/getInfosBySid',
			type: 'jsonp',
			formatRule (params) {
				return {
					sids: params.sids,
					clientInfo,
					role: 'seller',
					sid: params.bid
				};
			}
		};
	},

	// getServiceUrl() {
	// 	return {
	// 		url: urls.PCClientTrs + '/wd/seller/verify/getTicket',
	// 		formatRule: function (params) {
	// 			return {
	// 				param: JSON.stringify({
	// 					"userID": params.userID,
	// 					"wduss": params.wduss
	// 				})
	// 			}
	// 		}
	// 	}
	// },

	getTicket() {
		let {
			getTicketUrl
		} = urls;

		return {
			url: getTicketUrl,
			type: 'jsonp',
			formatRule(uid) {
				return {
					uid,
					bizType: 'service',
					param: JSON.stringify({})
				};
			}
		};
	}
};



/** WEBPACK FOOTER **
 ** ./lib/request.rule.js
 **/